// extracted by mini-css-extract-plugin
module.exports = {"section":"SqlHelpListBox_section__3OlKA","title":"SqlHelpListBox_title__1V8x2","addButton":"SqlHelpListBox_addButton__2zLJY"};